import { IMAGES } from 'assets/images';
import EvaluationSubmission from 'models/EvaluationSubmission';
import React from 'react';
import Modal from 'view/components/common/Modal';

type EvaluationFinishedPopupProps = {
  evaluationPreview?: EvaluationSubmission;
  isOpen: boolean;
  onClose: () => void;
};

const EvaluationFinishedPopup: React.FC<EvaluationFinishedPopupProps> = ({
  evaluationPreview,
  isOpen,
  onClose,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div
        className="col"
        style={{
          width: 'min(30vw, 500px)',
          minWidth: '300px',
          alignItems: 'center',
        }}
      >
        <h1 style={{ color: 'var(--dark-green)' }}>Well done!</h1>
        <img
          src={IMAGES.characters.wormy_funky}
          alt="Wormy"
          className="celebration-image"
        />
      </div>
    </Modal>
  );
};

export default EvaluationFinishedPopup;
